import {
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { RequestsService } from './requests.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { SpinnerService } from '../layout/spinner.service';
import { SnackbarService } from '../layout/snackbars/snackbar.service';
import { MatTabChangeEvent, MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { MatBadge } from '@angular/material/badge';
import { OpenRequestsComponent } from './open-requests/open-requests.component';
import { InvoiceRequestsComponent } from './invoice-requests/invoice-requests.component';
import { ClosedRequestsComponent } from './closed-requests/closed-requests.component';
import { NotAssignedComponent } from './not-assigned/not-assigned.component';

@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    imports: [MatIconButton, MatTooltip, MatIcon, MatDivider, MatTabGroup, MatTab, MatTabLabel, MatBadge, OpenRequestsComponent, InvoiceRequestsComponent, ClosedRequestsComponent, NotAssignedComponent]
})
export class RequestsComponent implements OnInit {
  constructor(
    private requestService: RequestsService,
    private snackbarService: SnackbarService,
    private spinnerService: SpinnerService
  ) { }

  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;


  openCounter = 0;
  closedCounter = 0;
  invoicedCounter = 0;

  ngOnInit(): void {
    this.requestService.openCounter.subscribe(data => {
      this.openCounter = data;
    });
    this.requestService.invoicedCounter.subscribe(data => {
      this.invoicedCounter = data;
    });
    this.requestService.closedCounter.subscribe(data => {
      this.closedCounter = data;
    });


  }

  refresh() {
     this.requestService.refreshRequests(true);
  }

  tabChanged(event: MatTabChangeEvent): void{
    this.requestService.tabChanged(event.index);
  }

  // -- export --
  exportRequests() {
    this.spinnerService.startSpinner();
    this.requestService.getExcelFile().subscribe(
      (data) => {
        this.spinnerService.stopSpinner();
        this.download(data);
        this.snackbarService.openSuccessMessage('Export successful!');
      },
      (error: any) => {
        this.spinnerService.stopSpinner();
        this.snackbarService.openError(error.status);
      });
  }

  download(data: any): void {
    const blob = new Blob([data]);
    const blobURL = window.URL.createObjectURL(blob);
    const name = 'Requests.xlsx';
    const anchor = document.createElement('a');
    anchor.download = name;
    anchor.href = blobURL;
    document.body.appendChild(anchor); // required for firefox
    anchor.click();
    anchor.remove();
  }

  getOpenHeader(): string {
    return 'Open(' + this.openCounter + ')';
  }

  getInvoiceHeader(): string {
    return 'Invoice(' + this.invoicedCounter + ')';
  }

  getClosedHeader(): string {
    return 'Closed(' + this.closedCounter + ')';
  }

  getNewOpenCountMessages(): number{
    return this.requestService.openRequestsWithNewMessages;
  }

  getNewInvoiceCountMessages(): number{
    return this.requestService.invoiceRequestsWithNewMessages;
  }

  getNewClosedCountMessages(): number{
    return this.requestService.closedRequestsWithNewMessages;
  }

}
